import { create } from "zustand";
const useSharedLinksStore = create((set) => ({
    addLink: (link) => set((state) => ({
        links: [link, ...state.links]
    })),
    links: [
        {
            expireDate: "05/30/2025",
            features: {
                canSeeHistory: true,
                canUseChargerControls: false,
                canUseSchedule: true,
                liveViewOnly: false
            },
            link: "https://example.com/share/new-link-1",
            name: "New Link",
            status: "Active",
            views: 100
        },
        {
            expireDate: "05/30/2025",
            features: {
                canSeeHistory: false,
                canUseChargerControls: true,
                canUseSchedule: false,
                liveViewOnly: false
            },
            link: "https://example.com/share/new-link-2",
            name: "New Link",
            status: "Deactivated",
            views: 100
        },
        {
            expireDate: "05/30/2025",
            features: {
                canSeeHistory: false,
                canUseChargerControls: false,
                canUseSchedule: false,
                liveViewOnly: true
            },
            link: "https://example.com/share/new-link-3",
            name: "New Link",
            status: "Expired",
            views: 100
        },
        {
            expireDate: "05/30/2025",
            features: {
                canSeeHistory: true,
                canUseChargerControls: true,
                canUseSchedule: true,
                liveViewOnly: false
            },
            link: "https://example.com/share/new-link-4",
            name: "New Link",
            status: "Active",
            views: 100
        }
    ],
    removeLink: (linkUrl) => set((state) => ({
        links: state.links.filter((link) => link.link !== linkUrl)
    })),
    setLinks: (links) => set(() => ({
        links
    })),
    updateLink: (linkUrl, updatedData) => set((state) => ({
        links: state.links.map((link) => (link.link === linkUrl ? { ...link, ...updatedData } : link))
    }))
}));
export default useSharedLinksStore;
